import inview from './inview';
import sticky from './sticky';
import slider from './slider';
import waypointSections from './waypoint-sections';

export default {
    init() {
        inview.init()
        sticky.init()
        slider.init()
        waypointSections.init()

        this.loadHeroAnim()

        if( $('.login-video').length ){
            this.loadLoginVideo()
        }

        this.backToTop()
        this.deviceCheck()
        this.removeLineHeight()
        this.tabbedContentEnable()
        this.animateLinks()

        if( $('.offcanvas').length ){
            this.offcanvasToggle()
        }

        this.searchTerms()
        // this.ajaxSearch()
    },

    ajaxSearch(){
        $(".search-field").keyup(function() {
            if( $(this).val().length >= 4 ) {
                $(".offcanvas__search").addClass('offcanvas__search--active');
                $(".menu-offcanvas-navigation-container").addClass('menu-offcanvas-navigation-container--inactive');
            } else {
                $(".offcanvas__search").removeClass('offcanvas__search--active');
                $(".menu-offcanvas-navigation-container").removeClass('menu-offcanvas-navigation-container--inactive');
            }
        });

        $(".search-field").focusout(function() {
            $(".offcanvas__search").removeClass('offcanvas__search--active');
            $(".menu-offcanvas-navigation-container").removeClass('menu-offcanvas-navigation-container--inactive');
        });
    },

    searchTerms(){
        // Updated :contains jquery to be case insensitive
        $.expr[':'].icontains = function(a, i, m) {
            return $(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
        };

        // Grabs url params
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        // Creates param.search value which can needs to be not null in order to continue
        let value = params.search;

        if( value != null ){
            let valueUpper = value.toUpperCase();
            let bodyTextContent = document.documentElement.textContent.toUpperCase()
            let bodyInnerText = document.documentElement.innerText.toUpperCase()

            console.log(value);

            if ( ( bodyTextContent || bodyInnerText ).indexOf(valueUpper) > -1) {
                let elCheck = false;

                $("h2:icontains("+ value +")").html(function(_, html) {
                    $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                    elCheck = true;
                });

                if( elCheck === false ){
                    $("h3:icontains("+ value +")").html(function(_, html) {
                        $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                        elCheck = true;
                    });
                }

                if( elCheck === false ){
                    $("h4:icontains("+ value +")").html(function(_, html) {
                        $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                        elCheck = true;
                    });
                }

                if( elCheck === false ){

                    $("h5:icontains("+ value +")").html(function(_, html) {
                        $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                        elCheck = true;
                    });
                }

                if( elCheck === false ){
                    $("strong:icontains("+ value +")").html(function(_, html) {
                        $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                        elCheck = true;
                    });
                }

                if( elCheck === false ){
                    $("p:icontains("+ value +")").html(function(_, html) {
                        $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                        elCheck = true;
                    });
                }

                if( elCheck === false ){
                    $("li:icontains("+ value +")").html(function(_, html) {
                        $('<div id="search-scroll-to"></div>').prependTo( $(this) );
                        elCheck = true;
                    });
                }

                if( elCheck ){
                    $('html,body').animate({
                        scrollTop: $('#search-scroll-to').offset().top - 150
                    }, 500);
                }
            }
        }
    },

    removeLineHeight(){
        $('h2:has(span.h4)').addClass('has-sub');
        $('h2:has(span.h3)').addClass('has-sub');
        $('p:has(strong)').addClass('has-sub');
        $('p:has(span.h3)').addClass('has-sub');
        $('p:has(span.h2)').addClass('has-sub');
    },

    animateLinks(){
       $("a[href^=#]:not(.burger-toggle)").click(function(e) {
          e.preventDefault();
          var dest = $(this).attr('href');
          $('html,body').animate({ scrollTop: $(dest).offset().top }, 'slow');
       });
    },

    tabbedContentEnable(){

      const $links = $('.tab-links')

      if ($links.length) {
          $('.link-0').trigger("click");

          $('.tab-links a').click(function (e) {
              $('.tab-links a').removeClass('selected');
              $(this).addClass('selected');
              var attrLink = $(this).attr("data-attribute"); // will return the string "123"
              e.preventDefault()
              $('.tab-element').removeClass('active');
              $('#' + attrLink).addClass('active');
          });
      }
    },

    deviceCheck(){
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/)) {
            $('body').addClass('is-mobile')
        } else {
            $('body').addClass('is-desktop')
        }
    },

    backToTop(){
        $('.back-to-top').click(function (e) {
            console.log('test')
            e.preventDefault()
            $("html, body").animate({scrollTop: 0}, 1000);
        });
    },


    loadHeroAnim(){
        setTimeout(function(){
            $('.hero-anim').addClass('el-iv')
        }, 1000);
    },

    loadLoginVideo(){
        const video = $('.login-video');
        var WindowWidth = $(window).width();

        if (WindowWidth < 768) {
            //It is a small screen
            video.append("<source src='https://dw-sydney.s3.eu-west-2.amazonaws.com/mobile-video.mp4' type='video/mp4' >");
        } else {
            //It is a big screen or desktop
            video.append("<source src='https://dw-sydney.s3.eu-west-2.amazonaws.com/sydney_loader.mp4' type='video/mp4' >");
        }

        setTimeout(function(){
            $('.btn-login').addClass('loaded')
        }, 9000);


        $('.btn-login').click(function(e) {
            e.preventDefault()
            $('.form-login').addClass('load-in');
            $('.video-background').addClass('fade-out')
            $('.banner').removeClass('fade-out')
        })
    },

    offcanvasToggle(){
        const self = this

        $('.burger-toggle').click(function(e) {
            e.preventDefault()

            if( $('.burger-toggle').hasClass('burger-toggle--active') ) {
                self.navDeactivate()
            } else {
                self.navActivate()
            }
        })

        if( $('.mobile-nav .sub-menu').length ){
            $('.mobile-nav .sub-menu').each(function() {
                $(this).prepend('<li class="menu-item menu-item-object-page menu-item-back"><a href="#">Back</a></li>');
            });
        }

        $('.offcanvas .mobile-nav .menu-item-has-children > a').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.menu-item-has-children').find('.sub-menu').toggleClass('sub-menu--active');
        });

        $('.offcanvas .mobile-nav .menu-item-back a').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.sub-menu').removeClass('sub-menu--active');
        });
    },

    navActivate(){
        setTimeout(function () {
            $('.burger-toggle').addClass('burger-toggle--active')
        }, 300)

        $('body').addClass('offcanvas-active')
    },

    navDeactivate(){
        $('body').removeClass('offcanvas-active')

        setTimeout(function () {
            $('.burger-toggle').removeClass('burger-toggle--active')
        }, 200)
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js